import { uiKitAccordionComponent } from 'shared/components/UiKitComponents/UiKitAccordion/component';

export const accordion = {
  uiKitAccordion: uiKitAccordionComponent,
};
